import { FeeDetailDTO } from "@models/platform-analysis/entities/steps/fee";
import { Text, View } from "@react-pdf/renderer";
import { calculateFeeDetailColumnWidth } from "../../../utils";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { PDFStyleConfigs } from "../../../configs";
import { FeeAnalysisLabelConstants } from "@pages/platform-analysis-v2/_id/steps/fee/analysis/constants";

export const PDFLabelLineDetail = ({
  firstProductFeeDetails,
  hasTooManyFeeColumns,
  isExcludePerformanceFees,
}: {
  firstProductFeeDetails: FeeDetailDTO[];
  hasTooManyFeeColumns: boolean;
  isExcludePerformanceFees?: boolean;
}) => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const contentWidth = hasTooManyFeeColumns
    ? PDFStyleConfigs.FeeAnalysisFeeDetailContentWidthWithoutLogo
    : PDFStyleConfigs.FeeAnalysisFeeDetailContentWidth;

  const { pysColumnWidth, otherColumnWidth } = calculateFeeDetailColumnWidth(
    contentWidth,
    firstProductFeeDetails,
  );

  return (
    <View
      style={{
        flexDirection: "row",
        paddingLeft: 3,
        height: 25,
      }}
    >
      {firstProductFeeDetails.map((feeDetail, index) => {
        const width = feeDetail.isPysRefund ? pysColumnWidth : otherColumnWidth;

        return (
          <View
            key={index}
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: width,
              height: PDFStyleConfigs.FeeAnalysisLabelLineDetailHeight,
              marginRight: index === 0 ? "5px" : 0,
              marginLeft:
                index === firstProductFeeDetails.length - 1 ? "5px" : 0,
            }}
          >
            <Text
              style={{
                ...typographyStyle?.body2,
                fontSize: 7,
                textAlign: "center",
              }}
            >
              {feeDetail.isSmaFees
                ? isExcludePerformanceFees
                  ? FeeAnalysisLabelConstants.SMAFeesExcPerfPDF
                  : FeeAnalysisLabelConstants.SMAFees
                : feeDetail.name}
            </Text>
          </View>
        );
      })}
    </View>
  );
};
